import { detailFormDetailValues } from "../../../../shared/lib/businessMatchingFormUtils";

export default detailFormDetailValues;
